/* eslint-disable @typescript-eslint/no-explicit-any */
import MiiaFwConfig from '@/configs/config'
import { useApiGw } from '@/features/miiaFw/composables/useApiGw'
import { ERROR_MESSAGES } from '@/constants/error/errorMessage'
import { ERROR_CODES } from '@/constants/error/errorCode'
import type {
  GeoVerifyGeoserverStatusRequestParam,
  GeoVerifyGeoserverStatusResponseParam
} from '@/types/api/geoserver/geoserverTypes'

export const geoVerifyGeoserverStatusApi = () => {
  const callVerifyGeoserverStatus = async (
    arg: GeoVerifyGeoserverStatusRequestParam
  ): Promise<GeoVerifyGeoserverStatusResponseParam> => {
    return await new Promise((resolve, reject) => {
      useApiGw().invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.apiGwEndpointScreening,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        `/geoserver/verify`,
        // Lambda関数に渡す引数
        {
          function: 'verify_geoserver_status',
          params: {
            ...arg,
            system: MiiaFwConfig.config.sysId
          }
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (response: GeoVerifyGeoserverStatusResponseParam) => {
          resolve(response)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: any) => {
          reject({ message: message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject({ message: ERROR_MESSAGES[ERROR_CODES.API_EXECUTION_FAILED].message })
        },
        // 処理完了後に実行するコールバック
        () => {},
        false
      )
    })
  }

  return {
    callVerifyGeoserverStatus
  }
}
